export const ODIN_INPUT_CLASSNAME = "odin-input";
